import { ApiError } from '@atlassian/conversation-assistant-service-api/utils/api-error';

import { StreamErrorException } from './error-classes/StreamErrorException';

/**
 * Classifies whether an error thrown while processing the stream originated on the client/network side.
 */
export const isClientSideStreamingError = (error: unknown): boolean => {
	if (!error) {
		return false;
	}

	// Server-sent error chunks are wrapped as StreamErrorException and should be excluded
	if (error instanceof StreamErrorException) {
		return false;
	}

	// Any ApiError (or object exposing errorAttributes.statusCode) comes from the HTTP layer, so exclude
	if (
		error instanceof ApiError ||
		(error as { errorAttributes?: { statusCode?: unknown } })?.errorAttributes?.statusCode
	) {
		return false;
	}

	const message = (error as { message?: string })?.message;
	// When the backend terminates the stream abruptly we get a JSON parsing error, so we treat it as server-side
	// See onversation-assistant-service/src/services/assistance-service/read-json-stream/index.ts
	if (typeof message === 'string' && message.startsWith('Error Processing Stream Data')) {
		return false;
	}

	// Whatever remains is considered a client/network error
	return true;
};
